"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _IconButton = _interopRequireDefault(require("@material-ui/core/IconButton"));
var _InputAdornment = _interopRequireDefault(require("@material-ui/core/InputAdornment"));
var _InsertInvitation = _interopRequireDefault(require("@material-ui/icons/InsertInvitation"));
var _pickers = require("@material-ui/pickers");
var _dates = _interopRequireDefault(require("../helpers/dates"));
var _Input = _interopRequireDefault(require("../Input"));
var _excluded = ["id", "format", "value", "handleChange", "disabled", "minDate", "maxDate", "timePicker", "timeFormat", "error", "helperText"],
  _excluded2 = ["error", "helperText"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var DateInput = function DateInput(_ref) {
  var id = _ref.id,
    format = _ref.format,
    value = _ref.value,
    handleChange = _ref.handleChange,
    disabled = _ref.disabled,
    minDate = _ref.minDate,
    maxDate = _ref.maxDate,
    timePicker = _ref.timePicker,
    timeFormat = _ref.timeFormat,
    error = _ref.error,
    helperText = _ref.helperText,
    other = _objectWithoutProperties(_ref, _excluded);
  var _useState = (0, _react.useState)(value),
    _useState2 = _slicedToArray(_useState, 2),
    currentValue = _useState2[0],
    setCurrentValue = _useState2[1];
  (0, _react.useEffect)(function () {
    setCurrentValue(value);
  }, [value]);
  var getFormattedDate = function getFormattedDate(rawDate) {
    return timePicker ? (0, _dates["default"])(rawDate).format("".concat(format, " ").concat(timeFormat === '12h' ? 'hh:mmA' : 'HH:mm')) : (0, _dates["default"])(rawDate).format(format);
  };
  var CustomInput = function CustomInput(_ref2) {
    var errorProp = _ref2.error,
      helperTextProp = _ref2.helperText,
      otherProps = _objectWithoutProperties(_ref2, _excluded2);
    return /*#__PURE__*/_react["default"].createElement(_Input["default"], _extends({
      id: id,
      error: error,
      helperText: helperText,
      autoComplete: "off"
    }, otherProps, other, {
      value: otherProps.value ? otherProps.value : '',
      endAdornment: /*#__PURE__*/_react["default"].createElement(_InputAdornment["default"], {
        position: "end"
      }, /*#__PURE__*/_react["default"].createElement(_IconButton["default"], {
        disableRipple: true,
        size: "small"
      }, /*#__PURE__*/_react["default"].createElement(_InsertInvitation["default"], null)))
    }));
  };
  CustomInput.propTypes = {
    helperText: _propTypes["default"].string,
    error: _propTypes["default"].string
  };
  CustomInput.defaultProps = {
    helperText: undefined,
    error: undefined
  };
  var dateProps = {
    clearable: true,
    onChange: setCurrentValue,
    value: value ? (0, _dates["default"])(value) : value,
    minDate: minDate ? (0, _dates["default"])(minDate) : undefined,
    maxDate: maxDate ? (0, _dates["default"])(maxDate) : undefined,
    onAccept: function onAccept(val) {
      return handleChange(val ? val.format() : '');
    },
    TextFieldComponent: CustomInput,
    labelFunc: function labelFunc() {
      return currentValue ? getFormattedDate(currentValue) : '';
    }
  };
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, timePicker ? /*#__PURE__*/_react["default"].createElement(_pickers.DateTimePicker, _extends({
    ampm: timeFormat === '12h',
    disabled: disabled
  }, dateProps)) : /*#__PURE__*/_react["default"].createElement(_pickers.DatePicker, _extends({
    disabled: disabled
  }, dateProps)));
};
DateInput.propTypes = {
  id: _propTypes["default"].string.isRequired,
  disabled: _propTypes["default"].bool,
  format: _propTypes["default"].string,
  timeFormat: _propTypes["default"].string,
  value: _propTypes["default"].string.isRequired,
  minDate: _propTypes["default"].string,
  maxDate: _propTypes["default"].string,
  timePicker: _propTypes["default"].bool,
  handleChange: _propTypes["default"].func.isRequired,
  helperText: _propTypes["default"].string,
  error: _propTypes["default"].string
};
DateInput.defaultProps = {
  disabled: false,
  timePicker: false,
  minDate: undefined,
  maxDate: undefined,
  format: 'LL',
  timeFormat: '24h',
  helperText: undefined,
  error: undefined
};
var _default = exports["default"] = DateInput;